const CN_DOWN_LINK = 'https://cms.jtexpress.com/tmp/print/CNPrintTool.zip'

export { CN_DOWN_LINK }
